import { App } from 'vue';
import * as Sentry from '@sentry/vue';
import type { Router } from 'vue-router';
import { isDevMode } from '../utils/env';

const initSentry = async (app: App<Element>, router: Router) => {
  const host = window.location.host;
  // 开发环境不使用 Sentry
  if (isDevMode() || host.includes('localhost')) {
    return;
  }
  let dsn = 'https://41c7ae608e98750f804d37fb9f6ee8f3@sentry.mcisaas.com/25';
  // 正则匹配域名获取环境、含有-dev的为开发环境、含有-stg的为测试环境、不含-的为生产环境
  let environment = 'production';
  // 开发环境
  const ipReg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (host.includes('-dev') || ipReg.test(host)) {
    environment = 'development';
    dsn = 'https://e9e4a0af9c1df7d7bcab470833a1b8e5@dev-sentry.mcisaas.com/9';
  }
  // 测试环境
  if (host.includes('-stg')) {
    environment = 'staging';
    dsn = 'https://e9e4a0af9c1df7d7bcab470833a1b8e5@dev-sentry.mcisaas.com/9';
  }
  // 仿真环境
  if (host.includes('-uat')) {
    environment = 'uat';
  }
  // 生产环境
  if (!host.includes('-')) {
    environment = 'production';
  }

  await Sentry.init({
    app,
    // 环境
    environment,
    dsn,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost'],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    // 忽略错误
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};

export async function setupSentry(app: App<Element>, router: Router) {
  await initSentry(app, router);
}
